import { SeoPage } from 'libs/shared-lib/interfaces';
export const VEHICLE_NOT_AVAILABLE_SEO_IT: SeoPage = {
    title: 'Il veicolo non è stato trovato',
    description: 'Il veicolo non è stato trovato',
    image: '',
    twitter: {
        card: 'summary',
        title: 'Il veicolo non è stato trovato',
        description: 'Il veicolo non è stato trovato',
    },
    og: {
        title: 'Il veicolo non è stato trovato',
        description: 'Il veicolo non è stato trovato',
    },
    robots: {
        noIndex: true,
        noFollow: true,
    },
};
